import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InsideLook } from './components/InsideLook';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="2wip36tktt20p">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="28te198rqp1kz">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="28s30zixi6bym">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="23utas12ahw9q">
      La prossima lezione può essere più semplice da guidare.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3rbrbqtqzs5he">
      <UrgencyBanner data-id="element-5" data-mp="4n6a3ahwrb3" />
      <main data-id="element-6" data-mp="56qxrrj5tst">
        <Hero data-id="element-7" data-mp="7ssnarqpf34" />
        <InsideLook data-id="element-8" data-mp="2zld0z6e9z99y" />
        <PackContents data-id="element-9" data-mp="2zlv84y2h77wn" />
        <InitialTestimonials data-id="element-10" data-mp="2zmem63p09c5e" />
        <PainPoints data-id="element-11" data-mp="2zng14j956ise" />
        <MethodOverview data-id="element-12" data-mp="33mf1dqjxhrdi" />
        <MoreTestimonials data-id="element-13" data-mp="33nq5xsl7735o" />
        <Guarantee data-id="element-14" data-mp="33mym1f0yqtv8" />
        <FAQ data-id="element-15" data-mp="33oi2b5mmd4x0" />
        <WhoItsFor data-id="element-16" data-mp="38lrrqla0dgku" />
        <TransitionPhrase data-id="element-17" data-mp="38li9jjv7gdpp" />
        <EmotionalClose data-id="element-18" data-mp="38l00tnrcw70w" />
      </main>
      <Footer data-id="element-19" data-mp="38o4d78ez692n" />
      <FloatingNotification data-id="element-20" data-mp="3dkl5met7j9lj" />
    </div>;
}